import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

type ThisApi = ApiDefinition['/district-templates/{id}']['PUT'];
type Input = ThisApi['params'] & ThisApi['body'];
type Output = ThisApi['response'];

/** Updates a district template's mutable fields. */
const updateDistrictTemplate = async ({ id, ...body }: Input): Promise<Output> => {
  const path = buildPath<ThisApi>('/district-templates/{id}', { id });
  const response = await noodleApiClient.put(path, body);
  return response.data;
};

export default updateDistrictTemplate;
